<template>
  <div class="catalog text-center">
    <h1>课程目录</h1>

    <div>
      <el-table
        :data="tableData"
        style="width: 100%"
        stripe
        :header-cell-style="{
          'text-align': 'center',
          background: '#fd4a29',
          color: '#fff',
        }"
        border
      >
        <el-table-column
          prop="section"
          label="章节"
          align="center"
          width="100"
        />
        <el-table-column prop="name" label="课程名称" align="center" />
      </el-table>
      <hr />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [
        {
          section: '第一讲',
          name: '生涯规划教育概述',
        },
        {
          section: '第二讲',
          name: '能力与兴趣',
        },
        {
          section: '第三讲',
          name: '生涯规划视角下如何认知性格及职业价值观',
        },
        {
          section: '第四讲',
          name: '认识大学及专业',
        },
        {
          section: '第五讲',
          name: '认识行业及职业',
        },
        {
          section: '第六讲',
          name: '认识新高考',
        },
        {
          section: '第七讲上',
          name: '如何进行高中选科',
        },
        {
          section: '第七讲下',
          name: '如何填报高考志愿',
        },
        {
          section: '第八讲',
          name: '新高考升学路径有哪些？',
        },
        {
          section: '第九讲',
          name: '强基计划整体解读',
        },
        {
          section: '第十讲',
          name: '生涯关键能力储备',
        },
        {
          section: '第十一讲',
          name: '如何培养人际能力及情绪管理与训练',
        },
        {
          section: '第十二讲',
          name: '高效的学习方法',
        },
      ],
    }
  },
}
</script>
<style lang="less" scoped>
.catalog {
  margin: 20px;
}
h1 {
  font-size: 22px;
  margin: 20px;
}
hr {
  background: #fe846e;
  height: 5px;
  border: none;
}
.table {
  padding: 40px 0;
}
/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #fcf9f6;
  border: none;
}
/deep/ .el-table--border th {
  border-right: none !important;
}
/deep/ .el-table--border td {
  border-right: none !important;
}
</style>
